<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A2CagX/tc-custom/9781609253233.jpg?1718219584158" alt="This image is the cover for the book Stick-to-it-iveness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stick-to-it-iveness
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Stick-to-it-iveness is a funny word,” Addie Johnson writes in the introduction of this small profound volume.</b></p><p> “Some might say it’s not even a real word, but it speaks for itself.” In her winsome, quirky, inspirational style, Johnson shares ideas that inspire us to make light of the hard work of achieving our dreams. This is a book that attests to the power of a little bit at a time. There’s a simple key to accomplishing our wildest dreams—a secret, hidden in plain view--sticking to it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Addie Johnson
      </h2>
      
      <p class="authorDescription body article"><B> Addie Johnson grew up in Minnesota and San Francisco, went east to go to Vassar College, and stayed put in New York. She's an actor and helps run Rising Phoenix Rep, a small developmental theatre company. She's also an editor and writer, and this is her second book. She lives in Brooklyn with her family, who help her remember every day that life is sweet. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Red Wheel/Weiser, llc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?648bfc15